import * as React from "react";
import axios from 'axios';
import styled from "styled-components";

import { useNavigate, useLocation } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import Modal from '@mui/material/Modal';
import { API_BASE_URL } from '../../config/apiConfig';

// Import components
import ProfileDetails from './components/ProfileDetails';
import Subscription from './components/Subscription';
import Lists from './components/Lists';
import Dealsboard from './components/Dealsboard';
import WallofElts from './components/WallofElts';
import Merch from './components/Merch';
import Brands from './components/Brands';
import OrderHistory from './components/OrderHistory';
//import WelcomeModal from './components/WelcomeModal';

import welcome_cat1 from '../../assets/welcome-cat1.png';
import welcome_cat2 from '../../assets/welcome-cat2.png';
import welcome_background from '../../assets/welcome-background.png';

// Import styled components
import {
  ProfileContainer,
  HeaderContainer,
  ProfileImage,
  Hamburger,
  HamburgerImg,
  Nav,
  NavItem,
  CloseButton,
  NavigationLinks,
  Link,
  DesktopOnlyLink,
  MobileOnlyLink,
  SocialSection,
  SocialLink,
  HelpLink,
  SocialLabel,
  SocialIcon,
  SocialText,
  Footer,
  FooterWrapper,
  MainContent
} from './styled/ProfileStyles';

// Import assets
import HamburgerIcon from '../../assets/hamburger-icon.png';
import { socialIcon, spoeltLogo, profileImage } from '../../assets/images';

export function Profile() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showProfileDetails, setShowProfileDetails] = React.useState(false);
  const [showSubscription, setShowSubscription] = React.useState(false);
  const [showLists, setShowLists] = React.useState(false);
  const [showDealsboard, setShowDealsboard] = React.useState(true);
  const [showWallofElts, setShowWallofElts] = React.useState(false);
  const [showMerch, setShowMerch] = React.useState(false);
  const [showBrands, setShowBrands] = React.useState(false);
  const [showOrderHistory, setShowOrderHistory] = React.useState(false);
  const [profile, setProfile] = React.useState(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [isSubscriptionActive, setIsSubscriptionActive] = React.useState(false);
  const [isSubscriptionWaived, setIsSubscriptionWaived] = React.useState(false);
  const [isWhitelisted, setIsWhitelisted] = React.useState(false);

  // Email allowlist for product visibility
  const allowedEmails = React.useMemo(() => ([
    'cyraacshdfc@gmail.com',
    'venu.terdal@gmail.com',
    'spoelt.me@gmail.com',
    'spoelt.test@gmail.com',
    'spoelt.test0@gmail.com',
    'spoelt.test1@gmail.com',
    'spoelt.test2@gmail.com',
    'digitalindiaventures@gmail.com',
    'digitalventuresindia@gmail.com',
    'snehajavali@gmail.com'
  ]), []);

  // Determine subscription active status from backend
  React.useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      setIsSubscriptionActive(false);
      setIsSubscriptionWaived(false);
      return;
    }
    axios.get(`${API_BASE_URL}/subscription/current`, {
      headers: { Authorization: token }
    }).then(res => {
      const data = res?.data?.data;
      const has = !!data?.has_subscription;
      const sub = data?.subscription;
      const active = has && sub && (sub.status === 'active');
      const waived = has && sub && sub.waived === true;
      setIsSubscriptionActive(!!active);
      setIsSubscriptionWaived(!!waived);
    }).catch(() => {
      setIsSubscriptionActive(false);
      setIsSubscriptionWaived(false);
    });
  }, []);

  React.useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      axios.post(`${API_BASE_URL}/user/get-profile`, {}, {
        headers: { Authorization: token }
      }).then(response => {
        setProfile(response.data.data[0]);
        const email = response?.data?.data?.[0]?.email || '';
        setIsWhitelisted(allowedEmails.includes(email));
        console.log(response.data.data[0]);
        if (!response.data.data[0].pincode) {
          setShowModal(true);
        }
      }).catch(error => {
        console.error('Error fetching profile', error);
      });
    } else {
      navigate('/');
    }

    // Check for URL parameters to show specific sections
    const urlParams = new URLSearchParams(location.search);
    const section = urlParams.get('section');
    
    if (section === 'subscription') {
      // Show subscription section when coming from successful payment
      setShowProfileDetails(false);
      setShowSubscription(true);
      setShowLists(false);
      setShowDealsboard(false);
      setShowWallofElts(false);
      setShowMerch(false);
      setShowBrands(false);
      setShowOrderHistory(false);
      setIsMenuOpen(false);
    }

    if (location.state && location.state.fromShipping) {
      setShowModal(true);
    }
  }, [location.state, location.search, navigate]);

  // Handle URL parameter for orders section after profile is loaded
  React.useEffect(() => {
    if (profile) {
      const urlParams = new URLSearchParams(location.search);
      const section = urlParams.get('section');
      
      if (section === 'orders' && (isSubscriptionActive || isSubscriptionWaived)) {
        // Show order history section when coming from successful product order (only for whitelisted users)
        setShowProfileDetails(false);
        setShowSubscription(false);
        setShowLists(false);
        setShowDealsboard(false);
        setShowWallofElts(false);
        setShowMerch(false);
        setShowBrands(false);
        setShowOrderHistory(true);
        setIsMenuOpen(false);
      }
    }
  }, [profile, location.search, isSubscriptionActive, isSubscriptionWaived]);

  const handleShare = (platform) => {
    const url = "http://spoelt.com";
    const message = `Hey, I just got into an exclusive community that curates amazing deals for its community members. They have limited open subscriptions, use this link to join the community and you’ll never have to pay retail price for your large purchases ever again.`;
    if (platform === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)} ${encodeURIComponent(url)}`, '_blank');
    } else if (platform === 'instagram') {
      window.open(`https://www.instagram.com/?url=${encodeURIComponent(url)}`, '_blank');
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem('token');
    navigate('/');
  };

  const navigateToBrands = () => {
    setShowProfileDetails(false);
    setShowSubscription(false);
    setShowLists(false);
    setShowDealsboard(false);
    setShowWallofElts(false);
    setShowBrands(true);
    setIsMenuOpen(false);
    setShowMerch(false);
    setShowOrderHistory(false);
  };

  return (
    <ProfileContainer style={{ backgroundColor: '#000' }}>
      <MainContent $bgColor={(showDealsboard || showWallofElts) ? '#e9fe53' : '#fff'} $reducedPadding={showMerch}>
        <HeaderContainer>
        <ProfileImage loading="lazy" src={profileImage} onClick={() => navigate("/")} />
        <Hamburger onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <HamburgerImg src={HamburgerIcon} alt="Menu" />
        </Hamburger>
      </HeaderContainer>
      
      <Nav $isOpen={isMenuOpen} $$isActive={!(showDealsboard || showWallofElts)}>
        <CloseButton hidden={!isMenuOpen} onClick={() => setIsMenuOpen(false)}>Close x</CloseButton>
        <NavItem 
          style={{ backgroundColor: showDealsboard ? (window.innerWidth <= 991 ? '#e9fe53' : 'white') : 'transparent' }} 
          onClick={() => { setShowProfileDetails(false); setShowSubscription(false); setShowLists(false); setShowDealsboard(true); setShowWallofElts(false); setIsMenuOpen(false); setShowMerch(false); setShowBrands(false); setShowOrderHistory(false); }}
        >
          Dealsboard
        </NavItem>
        <NavItem 
          $isActive={!(showDealsboard || showWallofElts) && showLists} 
          onClick={() => { setShowProfileDetails(false); setShowSubscription(false); setShowLists(true); setShowDealsboard(false); setShowWallofElts(false); setIsMenuOpen(false); setShowMerch(false); setShowBrands(false); setShowOrderHistory(false); }}
        >
          Lists
        </NavItem>
        <NavItem 
          $isActive={!(showDealsboard || showWallofElts) && showMerch} 
          onClick={() => { setShowProfileDetails(false); setShowSubscription(false); setShowLists(false); setShowDealsboard(false); setShowWallofElts(false); setShowMerch(true); setIsMenuOpen(false); setShowBrands(false); setShowOrderHistory(false); }}
        >
          Merch
        </NavItem>
        <NavItem 
          style={{ backgroundColor: showWallofElts ? (window.innerWidth <= 991 ? '#e9fe53' : 'white') : 'transparent' }} 
          onClick={() => { setShowProfileDetails(false); setShowSubscription(false); setShowLists(false); setShowDealsboard(false); setShowWallofElts(true); setIsMenuOpen(false); setShowMerch(false); setShowBrands(false); setShowOrderHistory(false); }}
        >
          Wall of ELTS
        </NavItem>
        <NavItem 
          $isActive={!(showDealsboard || showWallofElts) && showProfileDetails} 
          onClick={() => { setShowProfileDetails(true); setShowSubscription(false); setShowLists(false); setShowDealsboard(false); setShowWallofElts(false); setIsMenuOpen(false); setShowMerch(false); setShowBrands(false); setShowOrderHistory(false); }}
        >
          Profile
        </NavItem>
        <NavItem 
          $isActive={!(showDealsboard || showWallofElts) && showSubscription} 
          onClick={() => { setShowProfileDetails(false); setShowSubscription(true); setShowLists(false); setShowDealsboard(false); setShowWallofElts(false); setIsMenuOpen(false); setShowMerch(false); setShowBrands(false); setShowOrderHistory(false); }}
        >
          Subscription
        </NavItem>
        {(isSubscriptionActive || isSubscriptionWaived) && (
          <NavItem 
            $isActive={!(showDealsboard || showWallofElts) && showOrderHistory} 
            onClick={() => { setShowProfileDetails(false); setShowSubscription(false); setShowLists(false); setShowDealsboard(false); setShowWallofElts(false); setShowBrands(false); setIsMenuOpen(false); setShowMerch(false); setShowOrderHistory(true); }}
          >
            Orders
          </NavItem>
        )}
        <NavItem 
          $isActive={!(showDealsboard || showWallofElts) && showBrands} 
          onClick={() => { setShowProfileDetails(false); setShowSubscription(false); setShowLists(false); setShowDealsboard(false); setShowWallofElts(false); setShowBrands(true); setIsMenuOpen(false); setShowMerch(false); setShowOrderHistory(false); }}
        >
          Brands
        </NavItem>
      </Nav>
      
      {profile && showProfileDetails && <ProfileDetails profile={profile} setProfile={setProfile} />}
      {profile && showSubscription && <Subscription profile={profile} setProfile={setProfile} />}
      {profile && showLists && <Lists profile={profile} navigateToBrands={navigateToBrands} />}
      {showDealsboard && (
        <Dealsboard 
          isSubscriptionAllowed={(isSubscriptionActive) || isSubscriptionWaived} 
          onSubscribe={() => {
            setShowProfileDetails(false);
            setShowSubscription(true);
            setShowLists(false);
            setShowDealsboard(false);
            setShowWallofElts(false);
            setIsMenuOpen(false);
            setShowMerch(false);
            setShowBrands(false);
            setShowOrderHistory(false);
          }}
          navigateToLists={() => {
            setShowProfileDetails(false);
            setShowSubscription(false);
            setShowLists(true);
            setShowDealsboard(false);
            setShowWallofElts(false);
            setIsMenuOpen(false);
            setShowMerch(false);
            setShowBrands(false);
            setShowOrderHistory(false);
          }}
        />
      )}
      {showWallofElts && <WallofElts />}
      {showMerch && <Merch />}
      {showBrands && <Brands />}
      {showOrderHistory && (isSubscriptionActive || isSubscriptionWaived) && <OrderHistory />}
      </MainContent>
      
      <FooterWrapper>
        <NavigationLinks>
          <HelpLink>
            <Link onClick={() => window.open("/", "_blank")}>Home</Link>
            <Link onClick={() => window.open("/about", "_blank")}>About Us</Link>
            <Link onClick={() => window.open("/privacy#faqs", "_blank")}>FAQs</Link>
            <MobileOnlyLink onClick={handleLogout}>Logout</MobileOnlyLink>
          </HelpLink>
          <DesktopOnlyLink onClick={handleLogout}>Logout</DesktopOnlyLink>
        </NavigationLinks>
        
        <SocialSection>
          <SocialLink>
            <SocialLabel>Follow us on our socials:</SocialLabel>
            <SocialIcon loading="lazy" src={socialIcon} />
            <SocialText>@im_spoelt</SocialText>
          </SocialLink>
          <Footer>Copyright © 2024. SPOELT. All rights reserved</Footer>
        </SocialSection>
      </FooterWrapper>

     {/*  <WelcomeModal 
        showModal={showModal} 
        setShowModal={setShowModal} 
        handleShare={handleShare} 
      /> */}
       <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="welcome-modal-title"
        aria-describedby="welcome-modal-description"
      >
        <ModalContent>
          <CloseButtonModal onClick={() => setShowModal(false)}>Close ✖</CloseButtonModal>
          <HeroText>Welcome to</HeroText>
          <HeroLogo src={spoeltLogo} alt="Spoelt logo" />
          <WelcomeText>
            We're currently onboarding more like-minded users, <br/>limited subscriptions 
            are now open and product curation as per your lists 
            will begin shortly.
          </WelcomeText>

          <CatImagesContainer>
            <CatImageLeft src={welcome_cat1} alt="Welcome Cat 1" />
            <ShareButton onClick={() => handleShare('whatsapp')} style={{ marginTop: '-30px', marginBottom: '30px', width: '20%' }}>
              Share
            </ShareButton>
            <CatImageRight src={welcome_cat2} alt="Welcome Cat 2" />
          </CatImagesContainer>
        </ModalContent>
      </Modal>
    </ProfileContainer>
  );
}
const ShareButton = styled.button`
  border: 1px solid rgba(32, 32, 35, 1);
  border-radius: 1px;
  background-color: #e9fe53;
  height: 40px;
  margin-top: 40px;
  margin-bottom: 20px;
  width: 50%;
  max-width: 100%;
  gap: 8px;
  font-size: 16px;
  color: #202023;
  text-transform: uppercase;
  letter-spacing: -0.32px;
  line-height: 130%;
  @media (max-width: 991px) {
    padding: 10px;
    white-space: normal;
    margin-bottom: 20px;
    height: auto;
    width: 80%;
    font-size: 14px;
  }
`;

const CloseButtonModal = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  color: #202023;
`;

const ShareImage = styled.img`
  object-position: center;
  width: 30%;
  max-width: 100%;
  cursor: pointer;
`;

const WelcomeText = styled.div`
  color: #202023;
  letter-spacing: -0.28px;
  margin: 30px;
  margin-right: 40px;
  margin-left: 40px;
  text-align: center;
  font: 14px/18px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ModalContent = styled.div`
  background-color: white;
  background-image: url(${welcome_background}); 
  background-size: cover; 
  background-position: bottom; 
  margin-top: 160px;
  margin-left: 20%;
  margin-right: 20%;
  padding-top: 50px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  outline: none;
  text-align: center;
  align-items: center;
  position: relative; 
  @media (max-width: 991px) {
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 140px;
  }
`;

const CatImagesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  width: 100%;
`;

const CatImageLeft = styled.img`
  width: 20%; 
  object-fit: contain;
`;

const CatImageRight = styled.img`
  width: 20%; 
  object-fit: contain;
`;

const HeroText = styled.div`
  font-family: Inter, sans-serif;
  font-size: 80px;
  color: #202023;
  font-weight: 800;
  line-height: 108%;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 50px;
    margin-top: 20px;
  }
`;

const HeroLogo = styled.img`
  aspect-ratio: 4;
  object-fit: auto;
  object-position: center;
  width: 332px;
  align-self: start;
  margin-top: 8px;
  @media (max-width: 991px) {
    width: 220px;
  }
`;
//export default Profile;
